import { render, staticRenderFns } from "./MultipleUserSelect.vue?vue&type=template&id=640ff9fb&scoped=true&"
import script from "./MultipleUserSelect.vue?vue&type=script&lang=js&"
export * from "./MultipleUserSelect.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "640ff9fb",
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VBtn,VIcon})


/* hot reload */
if (module.hot) {
  var api = require("/srv/dev/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('640ff9fb')) {
      api.createRecord('640ff9fb', component.options)
    } else {
      api.reload('640ff9fb', component.options)
    }
    module.hot.accept("./MultipleUserSelect.vue?vue&type=template&id=640ff9fb&scoped=true&", function () {
      api.rerender('640ff9fb', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/TravelService/MultipleUserSelect.vue"
export default component.exports